import React from "react";
import { useSelector } from "react-redux";
import Portal from "components/Portal";
import Icon from "components/Icon";
import Button from "components/Button";
import { Spinner } from "styles/common";
import useLayout from "./useLayout";

import {
  StyledDialog,
  Container,
  Box,
  Header,
  LightBox,
  CloseButton,
  Body,
  IconContainer,
  Footer,
} from "./style";

const Dialog = ({
  children: Children,
  size,
  title,
  icon,
  type = "modal",
  align = "center",
  hideDelay = 0,
  cantClose = false,
  // height,
  customButtonActions,
  confirmLabel = "ادامه",
  cancelLabel = "انصراف",

  onClose = () => {},
  onConfirm = () => {},
  onCancel = () => {},
}) => {
  const {
    onLightBoxClick,
    setIgnoreClose,
    boxRef,
    bodyRef,
    closeHandler,
    calculateHeight,
    ignoreClose,
    close,
    animateEnded,
  } = useLayout(type, hideDelay, onClose, cantClose);
  const { tokenLoading } = useSelector((state) => state.user);

  return (
    <Portal>
      <StyledDialog $align={align}>
        <Container
          onMouseDown={onLightBoxClick}
          onMouseUp={(e) => e.preventDefault()}
        >
          <Box
            $size={size}
            $align={align}
            $type={type}
            $close={close}
            // $height={height}
            $animateEnded={animateEnded}
            ref={boxRef}
          >
            {type === "modal" && (
              <Header>
                {!ignoreClose && (
                  <CloseButton onClick={() => closeHandler(false)}>
                    <Icon name="cross" />
                  </CloseButton>
                )}
                {title && <h3>{title}</h3>}
                <div className="clear" />
              </Header>
            )}
            <Body $type={type} className="clearfix" ref={bodyRef}>
              {icon && (
                <IconContainer>
                  <Icon name={icon} />
                </IconContainer>
              )}
              {typeof Children === "function" ? (
                <Children
                  setModalIgnoreClose={setIgnoreClose}
                  closeModal={closeHandler}
                  calculateHeight={calculateHeight}
                />
              ) : (
                React.cloneElement(Children)
              )}

              {type === "alert" && hideDelay === 0 && (
                <Footer>
                  <Button size="sm" onClick={() => closeHandler(true)}>
                    بستن
                  </Button>
                </Footer>
              )}

              {type === "confirm" && (
                <Footer>
                  <Button
                    color="primary"
                    onClick={() => {
                      closeHandler(true);
                      onConfirm();
                    }}
                    size="sm"
                  >
                    {confirmLabel}
                  </Button>
                  <Button
                    color="primary"
                    link
                    onClick={() => {
                      closeHandler(true);
                      onCancel();
                    }}
                    size="sm"
                  >
                    {cancelLabel}
                  </Button>
                </Footer>
              )}

              {type === "custom" && customButtonActions && (
                <Footer>
                  {tokenLoading ? (
                    <Spinner />
                  ) : (
                    customButtonActions.map((item, i) => (
                      <Button
                        key={i}
                        color={item.color}
                        onClick={() => {
                          if (item.text === "انصراف") {
                            closeHandler(true);
                            onCancel();
                          } else {
                            item.onClick();
                            onConfirm();
                          }
                        }}
                        size={item.size}
                        {...item.other}
                      >
                        {item.text}
                      </Button>
                    ))
                  )}
                </Footer>
              )}
            </Body>
          </Box>
        </Container>
        <LightBox $close={close} $type={type} />
      </StyledDialog>
    </Portal>
  );
};

export default Dialog;
